<div class="max-w-[900px] flex flex-col justify-self-center pl-4 pr-4 mt-8 xl:mx-auto">
  <section class="mb-5">
    <h2 class="mb-5">BoxDelivery stopt met alle activiteiten</h2>
    <p>
      Beste klant, <br /><br />
      Met spijt moeten wij melden dat onze webshop stopt met alle activiteiten. <br />
      Door toenemende concurrentie en sterk stijgende prijzen is het voor ons niet langer mogelijk om onze
      dienstverlening op de vertrouwde manier voort te zetten.
    </p>
  </section>
  <section>
    <h3>Wat betekent dit voor jou?</h3>
    <ul class="list-disc gap-4">
      <li>Je kan <strong>geen nieuwe bestellingen</strong> meer plaatsen vanaf <strong>31/12/2025</strong></li>
      <li>Alle <strong>lopende bestellingen</strong> worden <strong>zorgvuldig afgehandeld</strong>.</li>
      <li>
        Voor <strong>vragen of ondersteuning</strong> blijven wij bereikbaar via
        <a href="mailto:info@boxdelivery.be" class="underline"><strong>e-mail: info&#64;boxdelivery.be</strong></a
        >.
      </li>
      <li>
        Bij de sluiting van de webshop worden <strong>geen klantgegevens verkocht, gedeeld of doorgegeven</strong> aan
        derde partijen. Jouw privacy blijft volledig gewaarborgd.
      </li>
    </ul>

    <h3>Kloostertrots</h3>
    <p>
      Alle Kloostertrots producten zijn uiterlijk 26/01 opnieuw beschikbaar op
      <a class="underline" href="https://www.kloostertrots.shop/">https://www.kloostertrots.shop/</a>
    </p>
    <br />
    <p>Wij willen al onze klanten hartelijk bedanken voor het vertrouwen en de steun in de afgelopen periode.</p>

    <p>
      Met vriendelijke groet,<br />
      <strong>BoxDelivery</strong>
    </p>
  </section>
</div>
